export default __webpack_public_path__ + "static/media/Group_198.55600576.svg";